import { APIError } from "libs/api/client";
import { useTransaction } from "libs/hooks/useTransaction";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { requestPasswordReset } from "../client_apis";
import { PasswordResetRequestFormValues } from "../types";

const defaultValues: PasswordResetRequestFormValues = {
  email: "",
};

export const usePasswordResetRequestForm = () => {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<null | "network">(null);

  const errorMessage = useMemo(() => {
    if (error == null) {
      return undefined;
    }

    return "通信エラーが発生しました";
  }, [error]);

  const form = useForm<PasswordResetRequestFormValues>({
    shouldUnregister: false,
    defaultValues,
    mode: "onChange",
  });

  const { watch, handleSubmit } = form;

  const email = watch("email");
  const isFormValid = useMemo(() => email.trim().length > 0, [email]);

  const [submitStatus, handleSubmitImpl] = useTransaction(
    async (values: PasswordResetRequestFormValues) => {
      setError(null);
      setSent(false);

      return await requestPasswordReset({ email: values.email.trim() });
    },
  );

  useEffect(() => {
    if (submitStatus.complete && submitStatus.callbackResult?.success) {
      setSent(true);
      toast.success("パスワードリセットメールを送信しました");
    }
  }, [submitStatus.complete, submitStatus.callbackResult]);

  useEffect(() => {
    if (submitStatus.error == null) {
      return;
    }

    const e = submitStatus.error;
    if (e instanceof APIError) {
      setError("network");
    } else {
      setError("network");
    }
  }, [submitStatus.error]);

  return {
    form,
    errorMessage,
    submitStatus,
    isFormValid,
    sent,
    handleSubmit: handleSubmit(handleSubmitImpl),
  };
};
